export default __webpack_public_path__ + "static/media/pexels-photo-3184398.8a94d5ae.jpeg";